<script setup>
  import { ref, computed, watch, onMounted } from 'vue';

  const props = defineProps({
    modelValue:   {},
    iconPosition: { type: String, default: 'left' },
    placeholder:  { type: String }, 
  })

  const emit  = defineEmits(['update:modelValue'])

  const model = ref()

  const onChangeInput = (e) => {
    emit('update:modelValue', e.value)
  }

  watch(() => props.modelValue, (newVal) => {
    // console.log('CurrencyInput modelValue', newVal)
    model.value = newVal
  })

  onMounted(() => {
    model.value = props.modelValue
  })
</script>

<template lang="pug">
  InputNumber(
    v-model="model"
    :placeholder="placeholder"
    @input="onChangeInput"
    prefix="$ "
    locale="en-US"
    :step="$attrs.step || 0.01"
    :minFractionDigits="$attrs.minFractionDigits || 2"
    :maxFractionDigits="$attrs.maxFractionDigits || 2"
  )
  //- pre $attrs: {{$attrs}}
  //- mode="currency"
  //- currency="USD"
  //- locale="en-US"
</template>